import { BaseEdge, type EdgeProps, getSmoothStepPath } from "@xyflow/react"

interface NewSegmentEdgeProps extends EdgeProps {
  data: {
    show: boolean
  }
}

const NewSegmentEdge = ({
  id,
  targetX,
  targetY,
  sourceX,
  sourceY,
  sourcePosition,
  targetPosition,
  data
}: NewSegmentEdgeProps) => {
  const [edgePath] = getSmoothStepPath({
    borderRadius: 16,
    offset: 0,
    sourcePosition,
    sourceX,
    sourceY,
    targetPosition,
    targetX,
    targetY
  })

  const lineStyle = {
    stroke: "var(--color-blue-300)",
    strokeDasharray: 8,
    strokeWidth: 2,
    zIndex: 10
  }

  return (
    <BaseEdge
      className={data.show ? "visible" : "invisible"}
      id={id}
      path={edgePath}
      style={lineStyle}
    />
  )
}

export default NewSegmentEdge
